const message = {
  news: "Novedades",
  btnShowMore: "Ver más",
  featuredArticles: "Artículos <span class='text-green'>destacados</span> ",
  lastNews: "últimas noticias",
  next: "siguiente >",
  previous: "< Anterior",
};
export default message;
